export default __webpack_public_path__ + "static/middlesex-b9ace9f68f3243767dc3467b537eac6f.jpeg";